import { supabase } from './supabaseClient.js';

/**
 * Capa de autenticación (Supabase Auth): registro, login, recuperación de
 * contraseña, logout y obtención del perfil (rol) del usuario actual.
 * La persistencia de sesión la maneja el propio cliente de Supabase
 * (localStorage interno del SDK + autoRefreshToken).
 */

export async function signUp(email, password) {
  const { data, error } = await supabase.auth.signUp({ email, password });
  if (error) throw error;
  return data;
}

export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function requestPasswordReset(email) {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/`,
  });
  if (error) throw error;
}

export async function updatePassword(newPassword) {
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) throw error;
}

export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  return data.session;
}

export function onAuthStateChange(callback) {
  const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
  return () => sub.subscription.unsubscribe();
}

/**
 * Trae el perfil (incluye el rol 'admin' | 'operador') del usuario logueado.
 * El perfil se crea automáticamente vía trigger en Supabase al registrarse.
 */
export async function getMyProfile() {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user) return null;

  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, full_name, role')
    .eq('id', user.id)
    .single();
  if (error) throw error;
  return data;
}
